import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { getParentClientDetails } from "../../services/userServices";
import ParentClientDetails from "../../components/ParentClientCard/ParentClientCard";
import classes from "./ParentClient.module.css";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { useDispatch, useSelector } from "react-redux";
import { parentCLientIdActions } from "../../Store/parentClient";
import { generalStoreActions } from "../../Store/GeneralStore";
import BackdropComponent from "../../components/Spinner/Spinner";
import { useTranslation } from "react-i18next";

const validateRosterLockDate = (date) => (date !== "" ? new Date(date) : "");

const ParentClient = () => {
  const { t } = useTranslation(["parentclient"]);
  const { parentClientCode } = useParams();
  const dispatch = useDispatch();
  const requestStatusOptions = [
    {
      label: "In Progress",
      value: "In Progress",
    },
    {
      label: "On Hold",
      value: "On Hold",
    },
    {
      label: "Closed",
      value: "Closed",
    },
    {
      label: "Cancelled",
      value: "Cancelled",
    },
    {
      label: "Extended Training/Nesting - Full",
      value: "Extended Training/Nesting - Full",
    },
    {
      label: "Extended Training/Nesting - Partial",
      value: "Extended Training/Nesting - Partial",
    },
  ];
  const sortOptions = [
    {
      label: "Wave(low -> high)",
      value: "1",
    },
    {
      label: "Wave(high -> low)",
      value: "2",
    },
    {
      label: "RLD(new -> old)",
      value: "3",
    },
    {
      label: "RLD(old -> new)",
      value: "4",
    },
    {
      label: "Site(a -> z)",
      value: "5",
    },
    {
      label: "Site(z -> a)",
      value: "6",
    },
  ];
  const [parentClientData, setParentClientData] = useState([]);
  const [waveRoster, setWaveRoster] = useState([]);
  const [projectSearch, setProjectSearch] = React.useState("");
  const [clientLocation, setClientLocation] = React.useState("");
  const [initialData, setInitialData] = useState([]);
  const [requestStatus, setRequestStatus] = useState(
    requestStatusOptions[0].value,
  );
  const [loading, setLoading] = useState([false]);

  const [sortEvent, setSortEvent] = useState(sortOptions[0].value);

  const isFirstRender = useRef(true);

  const classReauestCreated = useSelector((state) => state.generalStore);

  const searchProjectUnique = [
    ...new Map(initialData.map((item) => [item["project"], item])).values(),
  ];

  const siteLocationUnique = [
    ...new Map(
      initialData.map((item) => [item["siteLocation"], item]),
    ).values(),
  ];

  const searchProject = {
    options: searchProjectUnique,
    getOptionLabel: (option) => option.program,
  };
  searchProject.options = searchProjectUnique;

  const searchSiteLocation = {
    options: siteLocationUnique,
    getOptionLabel: (option) => option.siteLocation,
  };
  searchSiteLocation.options = siteLocationUnique;

  const [locValue, setLocValue] = useState("");
  const [projectValue, setProjectValue] = useState("");

  const functionSearchProject = async (event, value, reason) => {
    if (value) {
      setProjectSearch(value.projectName);
      setProjectValue(value);
      dispatch(generalStoreActions.updateParentClientProject(value));
    } else {
      setProjectSearch("");
      setProjectValue("");
      dispatch(generalStoreActions.updateParentClientProject(""));
    }
    if (reason === "clear") {
      setProjectSearch("");
      setProjectValue("");
      dispatch(generalStoreActions.updateParentClientProject(""));
    }
  };

  const functionSearchClinetLocation = async (event, value, reason) => {
    setLoading(true);
    if (value) {
      setClientLocation(value.siteLocation);
      setLocValue(value);
      dispatch(generalStoreActions.updateSiteLocation(value));
    } else {
      setClientLocation("");
      setLocValue("");
      dispatch(generalStoreActions.updateSiteLocation(""));
    }
    if (reason === "clear") {
      setClientLocation("");
      setLocValue("");
      dispatch(generalStoreActions.updateSiteLocation(""));
    }
    setLoading(false);
  };
  const requestStatusChange = (event, value) => {
    setRequestStatus(event.target.value);
  };

  const getClassRequestDetails = async (parentCLientCode) => {
    let data = {
      parentClientCode: parentCLientCode,
    };
    const parentClientDetails = await getParentClientDetails(data);

    dispatch(parentCLientIdActions.updateParentClientId(parentCLientCode));
    dispatch(generalStoreActions.updateClassRequestButton(true));
    if (parentClientDetails.status === true) {
      let parentClient = parentClientDetails.data.clientDetails;
      let waveRoster = parentClientDetails.data.projectWaveRoasterDetails;
      for (const data of parentClient) {
        for (const waveData of waveRoster) {
          if (data.classRequestId == waveData.classRequestId) {
            data.waveRoster = JSON.parse(waveData.waveRoster);
          }
        }
      }
      dispatch(
        generalStoreActions.updateClassRequestNumbers(parentClient.length),
      );

      setProjectSearch("");
      setProjectValue("");
      setClientLocation("");
      setLocValue("");

      setInitialData(parentClient);
      setWaveRoster(parentClientDetails.data.projectWaveRoasterDetails);
      let data = await parentClient.filter(
        (item) => item.requestStatus === requestStatus,
      );
      sortOrderFunction(sortEvent, data);
      dispatch(generalStoreActions.updateClassRequestCreated(false));
      setLoading(false);
    }
  };

  const sortOrderFunction = (event, data) => {
    let sorted = data;

    switch (event) {
      case "1":
        sorted = [...data].sort((a, b) => a.wave - b.wave);
        break;
      case "2":
        sorted = [...data].sort((a, b) => b.wave - a.wave);
        break;
      case "3": {
        let values = [...data].map((val, i) => {
          return {
            ...val,
            rosterDate: validateRosterLockDate(val.rosterLockDate),
          };
        });
        sorted = values.toSorted(
          (a, b) => b.rosterDate.valueOf() - a.rosterDate.valueOf(),
        );
        break;
      }
      case "4":
        {
          let values = [...data].map((val, i) => {
            return {
              ...val,
              rosterDate: validateRosterLockDate(val.rosterLockDate),
            };
          });

          sorted = values.toSorted(
            (a, b) => a.rosterDate.valueOf() - b.rosterDate.valueOf(),
          );
        }
        break;
      case "5":
        sorted = [...data].sort((a, b) => {
          if (a.siteLocation.toLowerCase() > b.siteLocation.toLowerCase())
            return 1;
          return -1;
        });
        break;
      case "6":
        sorted = [...data].sort((a, b) => {
          if (a.siteLocation.toLowerCase() > b.siteLocation.toLowerCase())
            return -1;
          return 1;
        });
        break;
      default:
        break;
    }

    setParentClientData(sorted);
    dispatch(generalStoreActions.updateClassRequestNumbers(sorted.length));
  };

  const findWaveRosterByClassRequestId = (waveRoster, classRequestId) =>
    waveRoster.find((item) => item.classRequestId == classRequestId);

  const filterByProjectName = (data, projectName) => {
    if (projectName) {
      return data.filter((item) => item.projectName === projectName);
    }
    setProjectSearch("");
    setProjectValue("");
    return data;
  };

  const filterBySiteLocation = (data, siteLocation) => {
    if (siteLocation) {
      return data.filter((item) => item.siteLocation === siteLocation);
    }
    setClientLocation("");
    setLocValue("");
    return data;
  };

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      if (!cancelled) {
        setLoading(true);
      }

      try {
        const data = {
          parentClientCode: parentClientCode,
        };

        localStorage.setItem("parentClientCode", parentClientCode);

        const parentClientDetails = await getParentClientDetails(data);

        if (cancelled) return;

        if (!cancelled) {
          dispatch(
            parentCLientIdActions.updateParentClientId(parentClientCode),
          );
          dispatch(generalStoreActions.updateClassRequestButton(true));
        }

        if (parentClientDetails.status === true) {
          const parentClient = parentClientDetails.data.clientDetails;
          const waveRoster = parentClientDetails.data.projectWaveRoasterDetails;

          parentClient.forEach((item) => {
            const waveData = findWaveRosterByClassRequestId(
              waveRoster,
              item.classRequestId,
            );
            if (waveData) {
              item.waveRoster = JSON.parse(waveData.waveRoster);
            }
          });

          if (!cancelled) {
            dispatch(
              generalStoreActions.updateClassRequestNumbers(
                parentClient.length,
              ),
            );
            setInitialData(parentClient);
            setWaveRoster(parentClientDetails.data.projectWaveRoasterDetails);
          }

          let filteredData = parentClient.filter(
            (item) => item.requestStatus === requestStatus,
          );

          const projectNameValue = classReauestCreated.parentClinetProject;
          const siteLocation = classReauestCreated.siteLocation;

          if (!cancelled) {
            setProjectSearch(projectNameValue.projectName);
            setClientLocation(siteLocation.siteLocation);
            setLocValue(siteLocation);
            setProjectValue(projectNameValue);
          }

          filteredData = filterByProjectName(
            filteredData,
            projectNameValue.projectName,
          );
          filteredData = filterBySiteLocation(
            filteredData,
            siteLocation.siteLocation,
          );

          if (!cancelled) {
            sortOrderFunction(sortEvent, filteredData);
            dispatch(generalStoreActions.updateClassRequestCreated(false));
            isFirstRender.current = false;
          }
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to fetch parent client data:", error);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      cancelled = true;
    };
  }, [parentClientCode]);

  useEffect(() => {
    let cancelled = false;

    const fetchClassRequest = async () => {
      if (classReauestCreated.classRequestCreated === true) {
        try {
          await getClassRequestDetails(parentClientCode);
        } catch (error) {
          if (!cancelled) {
            console.error("Failed to fetch class request details:", error);
          }
        }
      }
    };

    fetchClassRequest();

    return () => {
      cancelled = true;
    };
  }, [classReauestCreated.classRequestCreated, parentClientCode]);

  useEffect(() => {
    if (!isFirstRender.current) {
      let statusFilter = initialData.filter(
        (item) => item.requestStatus === requestStatus,
      );
      let projectFilter = statusFilter.filter((item) => {
        if (projectSearch === "") {
          return item;
        } else {
          return item.projectName === projectSearch;
        }
      });
      let siteLocationFilter = projectFilter.filter((item) => {
        if (clientLocation === "") {
          return item;
        } else {
          return item.siteLocation === clientLocation;
        }
      });
      sortOrderFunction(sortEvent, siteLocationFilter);
    }
  }, [requestStatus, sortEvent, projectSearch, clientLocation]);

  return (
    <>
      {loading ? <BackdropComponent /> : null}
      <Grid className={"p-10px"} container spacing={2}>
        <Grid item xs={6}>
          <Autocomplete
            {...searchProject}
            id="clear-on-escape"
            clearOnEscape
            value={projectValue}
            getOptionLabel={(option) => (option.project ? option.project : "")}
            onChange={(event, value, reason) =>
              functionSearchProject(event, value, reason)
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("selectproject")}
                variant="standard"
              />
            )}
          />
        </Grid>
        <Grid item xs={6}>
          <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
              <InputLabel variant="standard" htmlFor="uncontrolled-native">
                {t("requeststatus")}
              </InputLabel>
              <NativeSelect
                onChange={(event, value) => requestStatusChange(event, value)}
                inputProps={{
                  name: "requestStatus",
                  id: "requestStatus",
                }}
              >
                {requestStatusOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </NativeSelect>
            </FormControl>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Autocomplete
            {...searchSiteLocation}
            id="clear-on-escape"
            value={locValue}
            getOptionLabel={(option) =>
              option.siteLocation ? option.siteLocation : ""
            }
            onChange={(event, value, reason) =>
              functionSearchClinetLocation(event, value, reason)
            }
            clearOnEscape
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("selectsite")}
                variant="standard"
              />
            )}
          />
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <InputLabel variant="standard" htmlFor="uncontrolled-native">
              {t("sort")}
            </InputLabel>
            <NativeSelect
              onChange={(event, value) => setSortEvent(event.target.value)}
              inputProps={{
                name: "sortOrder",
                id: "uncontrolled-native",
              }}
            >
              {sortOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </NativeSelect>
          </FormControl>
        </Grid>
      </Grid>

      <div className={classes.parentClientContainer}>
        <ParentClientDetails
          waveRosterData={waveRoster}
          parentClientData={parentClientData}
        ></ParentClientDetails>
      </div>
    </>
  );
};

export default ParentClient;
